import { Routes } from '@angular/router';

import { hisChildRoutes } from 'hisng';

const ROUTES: Routes = [
    // budget source (Mittelherkünft)
    {
        path: 'budgetSource',
        loadChildren: () => import( 'app/fs/res/finance/component/budget-source/budget-source-core.module' ).then(
            m => m.BudgetSourceCoreModule
        )
    },
    // project (Projekt)
    {
        path: 'project',
        loadChildren: () => import( 'app/fs/res/finance/component/project/project-core.module' ).then(
            m => m.ProjectCoreModule )
    },
    // projectChangeRequest (ProjektChangeRequest)
    {
        path: 'projectChangeRequest',
        loadChildren: () => import( 'app/fs/res/finance/component/project-change-request/project-change-request-core.module' ).then(
            m => m.ProjectChangeRequestCoreModule )
    },
    // third party funding notification (Drittmittelanzeige)
    {
        path: 'fundingNotification',
        loadChildren: () => import( 'app/fs/res/finance/component/funding-notification/funding-notification-core.module' ).then(
            m => m.FundingNotificationCoreModule )
    }

];

// eslint-disable-next-line @typescript-eslint/naming-convention
export const FinanceRoutesModule = hisChildRoutes( ROUTES );
